import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import moment from 'moment-timezone';
import { useForm } from 'ziphy-web-shared/basic/lib/forms';
import { Title } from 'ziphy-web-shared/basic/lib/simple';
import { $windowSize } from 'ziphy-web-shared/basic/utils';
import { $router } from 'ziphy-web-shared/basic/utils/router';
import ApptsSearch from '@nedoShared/entityViews/appointments/apptsSearch/ApptsSearch';
import ApptsTabCurrent from '@nedoShared/features/appointments/apptsTabs/ApptsTabCurrent';
import ApptsTabHistory from '@nedoShared/features/appointments/apptsTabs/ApptsTabHistory';
import Toolbar from '@nedoShared/features/layouts/toolbar/Toolbar';
import { $appts } from '@store';
import { routeActions } from '@config/routeActions';
const Appts = ({ hasBurger }) => {
    const { t } = useTranslation();
    const viewInit = $router.searchParams.get('view') || 'current';
    const dateFromInit = $router.searchParams.get('dateFrom') || '';
    const dateToInit = $router.searchParams.get('dateTo') || '';
    const showFilters = Boolean(dateFromInit || dateToInit);
    const { form } = useForm({
        view: { value: viewInit },
        showFilters: { value: showFilters },
        practiceId: { value: null, prepValue: 'singleSelect' },
        dateFrom: { value: dateFromInit },
        dateTo: { value: dateToInit },
    });
    const practiceId = form.fields.practiceId.value;
    const dateFrom = form.fields.dateFrom.value;
    const dateTo = form.fields.dateTo.value
        ? moment(form.fields.dateTo.value).endOf('day').toISOString()
        : '';
    useEffect(() => {
        return () => {
            $router.searchParams.clear();
            try {
                void $appts.getActive();
            }
            catch (e) { }
        };
    }, []);
    return (_jsxs("div", Object.assign({ className: "content" }, { children: [_jsx(Toolbar, { hasBurger: hasBurger && $windowSize.isMobileSize, goBackProps: !hasBurger && { autoTarget: routeActions.ROOT() } }), _jsxs("div", Object.assign({ className: "container" }, { children: [_jsx(Title, Object.assign({ size: 'h1', className: 'mb-30' }, { children: t('label.appointments') })), _jsx(ApptsSearch, { filters: form.fields, className: 'mb-30' }), form.fields.view.value === 'current' && (_jsx(ApptsTabCurrent, { practiceId: practiceId, dateFrom: dateFrom, dateTo: dateTo })), form.fields.view.value === 'history' && (_jsx(ApptsTabHistory, { practiceId: practiceId, dateFrom: dateFrom, dateTo: dateTo }))] }))] })));
};
export default observer(Appts);
